// La Tocada secondary: stratocaster-style electric guitar.
// Silhouette = double-cutaway body + neck + headstock + cable.
// Used as alternative when the card is more "guitarist" than "vocalist."

interface GuitarStratProps {
  /** Body color (typically stage hot pink). */
  bodyColor?: string;
  /** Hardware / fretboard color (candy purple accent). */
  accentColor?: string;
  /** Rendered size in px (square bounding box). */
  size?: number;
  /** Optional className for positioning. */
  className?: string;
}

export function GuitarStrat({
  bodyColor = '#ff2e7e',
  accentColor = '#6b2d8c',
  size = 48,
  className,
}: GuitarStratProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      className={className}
      aria-hidden="true"
    >
      {/* Body — double cutaway (horns) bottom-right */}
      <path
        d="M14 28 Q14 22 20 22 L26 24 Q34 24 36 30 Q36 38 30 42 Q22 44 16 40 Q12 36 14 28 Z"
        fill={bodyColor}
      />
      {/* Body highlight — pickguard area */}
      <path
        d="M18 28 Q20 26 26 27 L30 32 Q30 36 26 37 Q22 37 19 33 Z"
        fill="rgba(0,0,0,0.25)"
      />
      {/* Pickups — 3 horizontal bars */}
      <rect x="20" y="29" width="8" height="1.5" fill={accentColor} />
      <rect x="20" y="32" width="8" height="1.5" fill={accentColor} />
      <rect x="20" y="35" width="8" height="1.5" fill={accentColor} />
      {/* Neck — angled up-left */}
      <path
        d="M14 26 L4 12 L6 10 L16 24 Z"
        fill={accentColor}
      />
      {/* Frets — 3 hash marks on neck */}
      <line x1="8" y1="18" x2="11" y2="20" stroke="rgba(255,255,255,0.5)" strokeWidth="0.8" />
      <line x1="6" y1="15" x2="9" y2="17" stroke="rgba(255,255,255,0.5)" strokeWidth="0.8" />
      <line x1="4" y1="12" x2="7" y2="14" stroke="rgba(255,255,255,0.5)" strokeWidth="0.8" />
      {/* Headstock */}
      <path d="M2 8 L6 10 L4 12 L0 10 Z" fill={accentColor} />
      {/* Tuner pegs */}
      <circle cx="1.5" cy="9" r="0.8" fill={bodyColor} />
      <circle cx="3" cy="11" r="0.8" fill={bodyColor} />
      {/* Cable — out the bottom, curling */}
      <path
        d="M34 40 Q40 42 42 38 Q42 34 38 36"
        stroke={accentColor}
        strokeWidth="1.8"
        strokeLinecap="round"
        fill="none"
      />
    </svg>
  );
}
